import { useMutation } from "@apollo/react-hooks";
import { ADD_SPENDING } from "../api/spending";
import { insertSpending, isWithinQueryWindow } from "../utils/spending";

export default (queryOption, onCompleted) => {
  return useMutation(ADD_SPENDING, {
    onCompleted,
    update(cache, { data: { addSpending } }) {
      // 月檢視下新增窗口外日期的紀錄時不動 cache；server 已寫入，
      // 切到涵蓋該日期的視圖時由 cache-and-network 撈回。
      if (!isWithinQueryWindow(addSpending.date, queryOption.variables)) {
        return;
      }

      const { spendings } = cache.readQuery(queryOption);

      const newSpendings = [...spendings];
      insertSpending(newSpendings, addSpending);

      cache.writeQuery({
        ...queryOption,
        data: { spendings: newSpendings },
      });
    },
  });
};
